export const AppointmentSlotBookingStatus = {
    INITIALIZED: "INITIALIZED",
    ACCEPT: "ACCEPT",
    PENDING: "PENDING",
    PAID: "PAID",
    ATTENDED: "ATTENDED",
    REJECTED: "REJECTED",
    DOCUMENT_SIGNED: "DOCUMENT_SIGNED",
    DOCUMENT_SIGN_PENDING: "DOCUMENT_SIGN_PENDING",
    APPOINTMENT_MEETING_LINK_SEND: "APPOINTMENT_MEETING_LINK_SEND",
    RETAINER_AGREEMENT_PENDING: "RETAINER_AGREEMENT_PENDING",
    RETAINER_AGREEMENT_SIGNED: "RETAINER_AGREEMENT_SIGNED",
    PAYMENT_PENDING: "PAYMENT_PENDING",
    AWAITING_EXTERNAL_PAYMENT: "AWAITING_EXTERNAL_PAYMENT",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    PAYMENT_SUCCESSFUL: "PAYMENT_SUCCESSFUL",
    CLOSED: "CLOSED",
    RESCHEDULE_REQUESTED: "RESCHEDULE_REQUESTED",
} as const;

export type AppointmentSlotBookingStatusType = keyof typeof AppointmentSlotBookingStatus;
